import React from 'react';
import {
	makeStyles,
	Button,
	Box,
	withStyles,
	FormControlLabel,
	Checkbox,
	Grid,
	MenuItem,
	Radio,
	TextField as TextField2,
} from '@material-ui/core';
import { Field, Form, Formik } from 'formik';
import DatePicker from '@mui/lab/DatePicker';
import { TextField } from 'formik-material-ui';
import { useHistory, useLocation } from 'react-router-dom';
import TitleText from '../components/reusableComponents/TitleText';
import BodyText from '../components/reusableComponents/BodyText';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { walletBalanceAgentDispatch } from '../reducers/UserReducer';
import { toggleGSTModal } from '../reducers/UiReducer';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import {
	FlightFareQuoteEtravDispatch,
	FlightFareQuoteDispatch,
	FlightAddBookingDispatch,
} from '../reducers/HomeReducer';
import { useDispatch, useSelector } from 'react-redux';
const title = ['Mr', 'Mrs'];
const useStyles = makeStyles((theme) => ({
	selectField: {
		'& .MuiOutlinedInput-root': {
			'& fieldset': {
				border: '1px solid #959595',
			},
		},
		backgroundColor: 'white',
		marginBottom: 30,
		width: '100%',
		marginTop: 10,
		borderRadius: 5,
		[theme.breakpoints.down('xs')]: {
			marginBottom: 15,
			marginTop: 8,
		},
		'& .MuiOutlinedInput-root': {
			borderRadius: 5,
		},
		'& .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root': {
			borderRadius: 5,
		},
	},
	InputPropsStyle: {
		backgroundColor: 'white',
		borderRadius: 15,
	},
	inputPropsStyle: {
		padding: 14,
	},
	createButton: {
		backgroundColor: 'rgb(239, 51, 57)',
		color: 'white',
		borderRadius: 12,
		width: '100%',
		padding: '11px 8px',
		'&:hover': {
			backgroundColor: 'rgb(239, 51, 57)',
		},
	},
	tabBorder: {
		borderBottom: '2px solid transparent',
		color: '#7B95AB',
		fontWeight: 400,
	},
	tabBorderColor: {
		borderBottom: '2px solid #313131',
		color: '#00325B',
		fontWeight: 700,
	},
	tab: {
		[theme.breakpoints.up('sm')]: {
			'& .MuiTab-root': {
				minWidth: 241,
				fontSize: 22,
			},
		},
	},
	date: {
		'& .MuiOutlinedInput-root': {
			borderRadius: 5,
			width: '100%',
		},
	},
	dob: {
		'& .MuiFormControl-root': {
			width: '100%',
		},
	},
	passport: {
		'& .MuiFormControl-root': {
			width: '100%',
		},
	},
	root: {
		'& .MuiFormHelperText-root': {
			fontSize: 12,
		},
		'& .MuiOutlinedInput-input': {
			fontSize: 14,
			padding: '13px 14px',
		},
		'& MuiInputLabel-root': {
			fontSize: 16,
		},
		'& .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root': {
			fontSize: 14,
		},
	},
	root2: {
		'& .MuiOutlinedInput-input': {
			fontSize: 14,
			padding: '13px 14px',
		},
		'& MuiInputLabel-root': {
			fontSize: 16,
		},
		'& .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root': {
			fontSize: 14,
		},
	},
}));
const FlightSummaryReturnForm = ({ time }) => {
	const classes = useStyles();
	const history = useHistory();
	const location = useLocation();
	const [value, setValue] = React.useState(new Date());
	const { etravflightFare } = useSelector((state) => state.ui);
	const { agentlogin } = useSelector((state) => state.user);
	const [child1, setChild1] = React.useState(new Date());
	const [child2, setChild2] = React.useState(new Date());
	const [child3, setChild3] = React.useState(new Date());
	const [child4, setChild4] = React.useState(new Date());
	const [child5, setChild5] = React.useState(new Date());
	const [child6, setChild6] = React.useState(new Date());
	const [infant1, setInfant1] = React.useState(new Date());
	const [infant2, setInfant2] = React.useState(new Date());
	const [infant3, setInfant3] = React.useState(new Date());
	const [infant4, setInfant4] = React.useState(new Date());
	const [infant5, setInfant5] = React.useState(new Date());
	const [infant6, setInfant6] = React.useState(new Date());
	const dispatch = useDispatch();
	const convert = (str) => {
		var date = new Date(str),
			mnth = ('0' + (date.getMonth() + 1)).slice(-2),
			day = ('0' + date.getDate()).slice(-2);
		return [date.getFullYear(), mnth, day].join('-');
	};
	console.log("first",location)
	const handleFormSubmit = (data) => {
		let FormData = [];
		if (data.titleA1) {
			FormData.push({
				title: data.titleA1,
				first_name: data.first_nameA1,
				last_name: data.last_nameA1,
				dob: '1998-02-06',
				PaxType: 1,
			});
		}
		if (data.titleA2) {
			FormData.push({
				title: data.titleA2,
				first_name: data.first_nameA2,
				last_name: data.last_nameA2,
				dob: '1998-02-06',
				PaxType: 1,
			});
		}
		if (data.titleA3) {
			FormData.push({
				title: data.titleA3,
				first_name: data.first_nameA3,
				last_name: data.last_nameA3,
				dob: '1998-02-06',
				PaxType: 1,
			});
		}
		if (data.titleA4) {
			FormData.push({
				title: data.titleA4,
				first_name: data.first_nameA4,
				last_name: data.last_nameA4,
				dob: '1998-02-06',
				PaxType: 1,
			});
		}
		if (data.titleA5) {
			FormData.push({
				title: data.titleA5,
				first_name: data.first_nameA5,
				last_name: data.last_nameA5,
				dob: '1998-02-06',
				PaxType: 1,
			});
		}
		if (data.titleA6) {
			FormData.push({
				title: data.titleA6,
				first_name: data.first_nameA6,
				last_name: data.last_nameA6,
				dob: '1998-02-06',
				PaxType: 1,
			});
		}
		if (data.titleA7) {
			FormData.push({
				title: data.titleA7,
				first_name: data.first_nameA7,
				last_name: data.last_nameA7,
				dob: '1998-02-06',
				PaxType: 1,
			});
		}
		if (data.titleA8) {
			FormData.push({
				title: data.titleA8,
				first_name: data.first_nameA8,
				last_name: data.last_nameA8,
				dob: '1998-02-06',
				PaxType: 1,
			});
		}
		if (data.titleA9) {
			FormData.push({
				title: data.titleA9,
				first_name: data.first_nameA9,
				last_name: data.last_nameA9,
				dob: '1998-02-06',
				PaxType: 1,
			});
		}
		if (data.titleC1) {
			FormData.push({
				title: data.titleC1,
				first_name: data.first_nameC1,
				last_name: data.last_nameC1,
				dob: convert(child1),
				PaxType: 2,
			});
		}
		if (data.titleC2) {
			FormData.push({
				title: data.titleC2,
				first_name: data.first_nameC2,
				last_name: data.last_nameC2,
				dob: convert(child2),
				PaxType: 2,
			});
		}
		if (data.titleC3) {
			FormData.push({
				title: data.titleC3,
				first_name: data.first_nameC3,
				last_name: data.last_nameC3,
				dob: convert(child3),
				PaxType: 2,
			});
		}
		if (data.titleC4) {
			FormData.push({
				title: data.titleC4,
				first_name: data.first_nameC4,
				last_name: data.last_nameC4,
				dob: convert(child4),
				PaxType: 2,
			});
		}
		if (data.titleC5) {
			FormData.push({
				title: data.titleC5,
				first_name: data.first_nameC5,
				last_name: data.last_nameC5,
				dob: convert(child5),
				PaxType: 2,
			});
		}
		if (data.titleC6) {
			FormData.push({
				title: data.titleC6,
				first_name: data.first_nameC6,
				last_name: data.last_nameC6,
				dob: convert(child6),
				PaxType: 2,
			});
		}
		if (data.titleI1) {
			FormData.push({
				title: data.titleI1,
				first_name: data.first_nameI1,
				last_name: data.last_nameI1,
				dob: convert(infant1),
				PaxType: 3,
			});
		}
		if (data.titleI2) {
			FormData.push({
				title: data.titleI2,
				first_name: data.first_nameI2,
				last_name: data.last_nameI2,
				dob: convert(infant2),
				PaxType: 3,
			});
		}
		if (data.titleI3) {
			FormData.push({
				title: data.titleI3,
				first_name: data.first_nameI3,
				last_name: data.last_nameI3,
				dob: convert(infant3),
				PaxType: 3,
			});
		}
		if (data.titleI4) {
			FormData.push({
				title: data.titleI4,
				first_name: data.first_nameI4,
				last_name: data.last_nameI4,
				dob: convert(infant4),
				PaxType: 3,
			});
		}
		if (data.titleI5) {
			FormData.push({
				title: data.titleI5,
				first_name: data.first_nameI5,
				last_name: data.last_nameI5,
				dob: convert(infant5),
				PaxType: 3,
			});
		}
		if (data.titleI6) {
			FormData.push({
				title: data.titleI6,
				first_name: data.first_nameI6,
				last_name: data.last_nameI6,
				dob: convert(infant6),
				PaxType: 3,
			});
		}
		if(location.state.selectedonward){
			if(location.state.selectedonward[0]?.Airline_Code&&location.state.selectedReturn[0]?.Airline_Code){
				let formEtravFare = {
					Search_Key: location.state.IDEtrav,
					AirRepriceRequests: [
						{
							Flight_Key: location.state.selectedonward[0]?.Flight_Key,
							Fare_Id: location.state.selectedonward[0]?.Fares.Fare_Id,
						},
						{
							Flight_Key: location.state.selectedReturn[0]?.Flight_Key,
							Fare_Id: location.state.selectedReturn[0]?.Fares.Fare_Id,
						},
					],
					Customer_Mobile: data.phone,
					GST_Input: false,
					SinglePricing: true,
					agent_id: agentlogin ? agentlogin.result.result.id : 0,
				};
	
				dispatch(FlightFareQuoteEtravDispatch(formEtravFare));
				history.push({
					pathname: '/confirmflight',
					state: {
						formData: data,
						orderID: location.state.orderID,
						returnBody: location.state.returnBody,
						IDTBO: location.state.IDTBO,
						IDEtrav: location.state.IDEtrav,
						BookingData: FormData,
						// orderID: location.state.orderID,
						selectedonward: location.state.selectedonward,
						selectedReturn: location.state.selectedReturn,
						
					},
				});
			}else if(location.state.selectedonward[0]?.Airline_Code&&location.state.selectedReturn[0]?.AirlineCode){
				if(location.state.selectedonward[0]?.Airline_Code){
					let formEtravFare = {
						Search_Key: location.state.IDEtrav,
						AirRepriceRequests: [
							{
								Flight_Key: location.state.selectedonward[0]?.Flight_Key,
								Fare_Id: location.state.selectedonward[0]?.Fares.Fare_Id,
							}
						],
						Customer_Mobile: data.phone,
						GST_Input: false,
						SinglePricing: true,
						agent_id: agentlogin ? agentlogin.result.result.id : 0,
					};
		
					dispatch(FlightFareQuoteEtravDispatch(formEtravFare));
					history.push({
						pathname: '/confirmflight',
						state: {
							formData: data,
							orderID: location.state.orderID,
							returnBody: location.state.returnBody,
							IDTBO: location.state.IDTBO,
							IDEtrav: location.state.IDEtrav,
							BookingData: FormData,
							// orderID: location.state.orderID,
							selectedonward: location.state.selectedonward,
							selectedReturn: location.state.selectedReturn,
						},
					});
				}
				if(location.state.selectedReturn[0]?.AirlineCode){
					let formData1 = {
						TraceId: location.state.IDTBO,
						ResultIndex: location.state.selectedReturn[0].ResultIndex,
						agent_id: agentlogin ? agentlogin.result.result.id : 0,
					};
	
					dispatch(FlightFareQuoteDispatch(formData1));
				}
			}else if(location.state.selectedReturn[0]?.Airline_Code&&location.state.selectedonward[0]?.AirlineCode){
				if(location.state.selectedReturn[0].Airline_Code){
					let formEtravFare = {
						Search_Key: location.state.IDEtrav,
						AirRepriceRequests: [
							{
								Flight_Key: location.state.selectedReturn[0].Flight_Key,
								Fare_Id: location.state.selectedReturn[0].Fares.Fare_Id,
							}
						],
						Customer_Mobile: data.phone,
						GST_Input: false,
						SinglePricing: true,
						agent_id: agentlogin ? agentlogin.result.result.id : 0,
					};
		
					dispatch(FlightFareQuoteEtravDispatch(formEtravFare));
					history.push({
						pathname: '/confirmflight',
						state: {
							formData: data,
							orderID: location.state.orderID,
							returnBody: location.state.returnBody,
							IDTBO: location.state.IDTBO,
							IDEtrav: location.state.IDEtrav,
							BookingData: FormData,
							// orderID: location.state.orderID,
							selectedonward: location.state.selectedonward,
							selectedReturn: location.state.selectedReturn,
						},
					});
				}
				if(location.state.selectedonward[0]?.AirlineCode){
					let formData1 = {
						TraceId: location.state.IDTBO,
						ResultIndex: location.state.selectedonward[0].ResultIndex,
						agent_id: agentlogin ? agentlogin.result.result.id : 0,
					};
	
					dispatch(FlightFareQuoteDispatch(formData1));
				}
			} else if(location.state.selectedonward[0]?.AirlineCode&&location.state.selectedReturn[0]?.AirlineCode){
				let formData1 = {
					TraceId: location.state.IDTBO,
					ResultIndex: location.state.selectedonward[0].ResultIndex,
					agent_id: agentlogin ? agentlogin.result.result.id : 0,
				};
				let formData2 = {
					TraceId: location.state.IDTBO,
					ResultIndex: location.state.selectedReturn[0].ResultIndex,
					agent_id: agentlogin ? agentlogin.result.result.id : 0,
				};
	
				dispatch(FlightFareQuoteDispatch(formData1));
				dispatch(FlightFareQuoteDispatch(formData2));
				history.push({
					pathname: '/confirmflight',
					state: {
						formData: data,
						orderID: location.state.orderID,
						returnBody: location.state.returnBody,
						IDTBO: location.state.IDTBO,
						IDEtrav: location.state.IDEtrav,
						BookingData: FormData,
						// orderID: location.state.orderID,
						selectedonward: location.state.selectedonward,
						selectedReturn: location.state.selectedReturn,
					},
				});
			}
		}
		if(location.state.intFlight){
			let formData1 = {
				TraceId: location.state.IDTBO,
				ResultIndex: location.state.intFlight.ResultIndex,
				agent_id: agentlogin ? agentlogin.result.result.id : 0,
			};

			dispatch(FlightFareQuoteDispatch(formData1));
			history.push({
				pathname: '/confirmflight',
				state: {
					formData: data,
					orderID: location.state.orderID,
					returnBody: location.state.returnBody,
					IDTBO: location.state.IDTBO,
					// IDEtrav: location.state.IDEtrav,
					BookingData: FormData,
					intFlight:location.state.intFlight
					// orderID: location.state.orderID,
					// selectedonward: location.state.selectedonward,
					// selectedReturn: location.state.selectedReturn,
				},
			});
		}
	
		console.log(data);
	};
	// console.log(location.state);
	return (
		<>
			<Formik
				initialValues={{
					email: '',
					phone: '',
					titleA1: '',
					first_nameA1: '',
					last_nameA1: '',
					titleA2: '',
					first_nameA2: '',
					last_nameA2: '',
					titleA3: '',
					first_nameA3: '',
					last_nameA3: '',
					titleA4: '',
					first_nameA4: '',
					last_nameA4: '',
					titleA5: '',
					first_nameA5: '',
					last_nameA5: '',
					titleA6: '',
					first_nameA6: '',
					last_nameA6: '',
				}}
				validate={(values) => {
					const errors = {};
					let isError = false;
					if (!values.email) {
						errors.email = 'Required';
						isError = true;
					} else if (
						!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
					) {
						errors.email = 'Invalid email address';
						isError = true;
					}
					if (!values.phone) {
						errors.phone = 'Required';
						isError = true;
					}
					if (!values.titleA1) {
						errors.titleA1 = 'Required';
						isError = true;
					}
					if (!values.first_nameA1) {
						errors.first_nameA1 = 'Required';
						isError = true;
					}
					if (!values.last_nameA1) {
						errors.last_nameA1 = 'Required';
					}
					// if (location.state.body.AdultCount === 2) {
					// 	if (!values.titleA2) {
					// 		errors.titleA2 = 'Required';
					// 		isError = true;
					// 	}
					// 	if (!values.first_nameA2) {
					// 		errors.first_nameA2 = 'Required';
					// 		isError = true;
					// 	}
					// 	if (!values.last_nameA2) {
					// 		errors.last_nameA2 = 'Required';
					// 	}
					// }
					// if (location.state.body.AdultCount === 3) {
					// 	if (!values.titleA2) {
					// 		errors.titleA2 = 'Required';
					// 		isError = true;
					// 	}
					// 	if (!values.first_nameA2) {
					// 		errors.first_nameA2 = 'Required';
					// 		isError = true;
					// 	}
					// 	if (!values.last_nameA2) {
					// 		errors.last_nameA2 = 'Required';
					// 	}
					// 	if (!values.titleA3) {
					// 		errors.titleA3 = 'Required';
					// 		isError = true;
					// 	}
					// 	if (!values.first_nameA3) {
					// 		errors.first_nameA3 = 'Required';
					// 		isError = true;
					// 	}
					// 	if (!values.last_nameA3) {
					// 		errors.last_nameA3 = 'Required';
					// 	}
					// }
					// if (location.state.body.AdultCount === 4) {
					// 	if (!values.titleA2) {
					// 		errors.titleA2 = 'Required';
					// 		isError = true;
					// 	}
					// 	if (!values.first_nameA2) {
					// 		errors.first_nameA2 = 'Required';
					// 		isError = true;
					// 	}
					// 	if (!values.last_nameA2) {
					// 		errors.last_nameA2 = 'Required';
					// 	}
					// 	if (!values.titleA3) {
					// 		errors.titleA3 = 'Required';
					// 		isError = true;
					// 	}
					// 	if (!values.first_nameA3) {
					// 		errors.first_nameA3 = 'Required';
					// 		isError = true;
					// 	}
					// 	if (!values.last_nameA3) {
					// 		errors.last_nameA3 = 'Required';
					// 	}
					// 	if (!values.titleA4) {
					// 		errors.titleA4 = 'Required';
					// 		isError = true;
					// 	}
					// 	if (!values.first_nameA4) {
					// 		errors.first_nameA4 = 'Required';
					// 		isError = true;
					// 	}
					// 	if (!values.last_nameA4) {
					// 		errors.last_nameA4 = 'Required';
					// 	}
					// }
					// if (location.state.body.AdultCount === 5) {
					// 	if (!values.titleA2) {
					// 		errors.titleA2 = 'Required';
					// 		isError = true;
					// 	}
					// 	if (!values.first_nameA2) {
					// 		errors.first_nameA2 = 'Required';
					// 		isError = true;
					// 	}
					// 	if (!values.last_nameA2) {
					// 		errors.last_nameA2 = 'Required';
					// 	}
					// 	if (!values.titleA3) {
					// 		errors.titleA3 = 'Required';
					// 		isError = true;
					// 	}
					// 	if (!values.first_nameA3) {
					// 		errors.first_nameA3 = 'Required';
					// 		isError = true;
					// 	}
					// 	if (!values.last_nameA3) {
					// 		errors.last_nameA3 = 'Required';
					// 	}
					// 	if (!values.titleA4) {
					// 		errors.titleA4 = 'Required';
					// 		isError = true;
					// 	}
					// 	if (!values.first_nameA4) {
					// 		errors.first_nameA4 = 'Required';
					// 		isError = true;
					// 	}
					// 	if (!values.last_nameA4) {
					// 		errors.last_nameA4 = 'Required';
					// 	}
					// 	if (!values.titleA5) {
					// 		errors.titleA5 = 'Required';
					// 		isError = true;
					// 	}
					// 	if (!values.first_nameA5) {
					// 		errors.first_nameA5 = 'Required';
					// 		isError = true;
					// 	}
					// 	if (!values.last_nameA5) {
					// 		errors.last_nameA5 = 'Required';
					// 	}
					// }
					// if (location.state.body.AdultCount === 6) {
					// 	if (!values.titleA2) {
					// 		errors.titleA2 = 'Required';
					// 		isError = true;
					// 	}
					// 	if (!values.first_nameA2) {
					// 		errors.first_nameA2 = 'Required';
					// 		isError = true;
					// 	}
					// 	if (!values.last_nameA2) {
					// 		errors.last_nameA2 = 'Required';
					// 	}
					// 	if (!values.titleA3) {
					// 		errors.titleA3 = 'Required';
					// 		isError = true;
					// 	}
					// 	if (!values.first_nameA3) {
					// 		errors.first_nameA3 = 'Required';
					// 		isError = true;
					// 	}
					// 	if (!values.last_nameA3) {
					// 		errors.last_nameA3 = 'Required';
					// 	}
					// 	if (!values.titleA4) {
					// 		errors.titleA4 = 'Required';
					// 		isError = true;
					// 	}
					// 	if (!values.first_nameA4) {
					// 		errors.first_nameA4 = 'Required';
					// 		isError = true;
					// 	}
					// 	if (!values.last_nameA4) {
					// 		errors.last_nameA4 = 'Required';
					// 	}
					// 	if (!values.titleA5) {
					// 		errors.titleA5 = 'Required';
					// 		isError = true;
					// 	}
					// 	if (!values.first_nameA5) {
					// 		errors.first_nameA5 = 'Required';
					// 		isError = true;
					// 	}
					// 	if (!values.last_nameA5) {
					// 		errors.last_nameA5 = 'Required';
					// 	}
					// 	if (!values.titleA6) {
					// 		errors.titleA6 = 'Required';
					// 		isError = true;
					// 	}
					// 	if (!values.first_nameA6) {
					// 		errors.first_nameA6 = 'Required';
					// 		isError = true;
					// 	}
					// 	if (!values.last_nameA6) {
					// 		errors.last_nameA6 = 'Required';
					// 	}
					// }
					return errors;
				}}
				onSubmit={handleFormSubmit}>
				{({ submitForm, isSubmitting, values, errors }) => (
					<>
						<Form>
							{/* Email and PhoneNumber Section */}
							<Box
								className={classes.root}
								style={{
									background: 'white',
									padding: '10px 15px',
									border: '1px solid #e6e6e6',
									marginTop: '10px',
									boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
									borderRadius: '5px',
								}}>
								<Grid
									container
									spacing={2}
									alignItems='center'
									style={{ marginTop: 20, alignItems: 'baseline' }}>
									<Grid item xs={12} lg={6}>
										<Field
											component={TextField}
											name='email'
											type='email'
											variant='outlined'
											error={errors.email}
											label='Email ID'
											className={classes.selectField}
											InputProps={{
												className: classes.InputPropsStyle,
											}}
											inputProps={{
												style: { padding: 12 },
											}}
										/>
									</Grid>
									<Grid item xs={12} lg={6}>
										<Field
											component={TextField}
											name='phone'
											type='number'
											variant='outlined'
											error={errors.phone}
											label='Mobile No.'
											className={classes.selectField}
											InputProps={{
												className: classes.InputPropsStyle,
											}}
											inputProps={{
												style: { padding: 12 },
											}}
										/>
									</Grid>
								</Grid>
							</Box>
							{location.state.returnBody.AdultCount === 1 && (
								<Box
									className={classes.root}
									style={{
										background: 'white',
										padding: '10px 15px',
										border: '1px solid #e6e6e6',
										marginTop: '10px',
										boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
										borderRadius: '5px',
									}}>
									<Box display='flex'>
										<TitleText three textStyle={{ marginTop: 10 }}>
											1
										</TitleText>
										<TitleText
											three
											textStyle={{ marginLeft: 5, marginTop: 10 }}>
											Adult
										</TitleText>
									</Box>
									<Grid
										container
										spacing={2}
										alignItems='center'
										style={{ marginTop: 20, alignItems: 'baseline' }}>
										<Grid
											item
											xs={12}
											sm={6}
											lg={4}
											className={classes.root2}
											style={{ alignItems: 'center' }}>
											<Field
												component={TextField}
												select
												name='titleA1'
												type='text'
												variant='outlined'
												label='Select Title'
												error={errors.titleA1}
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													className: classes.inputPropsStyle,
												}}>
												{title.map((item, index) => (
													<MenuItem key={index} value={item}>
														{item}
													</MenuItem>
												))}
											</Field>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='first_nameA1'
												type='text'
												error={errors.first_nameA1}
												variant='outlined'
												label='Enter First Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
										<Grid item xs={12} sm={6} lg={4}>
											<Field
												component={TextField}
												name='last_nameA1'
												type='text'
												error={errors.last_nameA1}
												variant='outlined'
												label='Enter Last Name'
												className={classes.selectField}
												InputProps={{
													className: classes.InputPropsStyle,
												}}
												inputProps={{
													style: { padding: 12 },
												}}
											/>
										</Grid>
									</Grid>
								</Box>
							)}
							<Box
								style={{
									background: 'white',
									padding: '10px 15px',
									border: '1px solid #e6e6e6',
									marginTop: '10px',
									boxShadow: '0 0.5rem 1rem rgb(0 0 0 / 15%)',
									borderRadius: '5px',
								}}>
								<Box
									display='flex'
									alignItems='center'
									onClick={() => {
										dispatch(toggleGSTModal(true));
									}}>
									<h6 style={{ color: '#007bff', cursor: 'pointer' }}>
										Add GST Details
									</h6>
								</Box>
								<Box>
									<span style={{ fontSize: 14 }}>
										NOTE: (1) GSTIN can’t be updated once booking is completed.
										(2) Your Taxes may get updated post submitting GST details.
									</span>
								</Box>
							</Box>
							{/* submit Button */}
							<Grid container spacing={4} alignItems='center'>
								<Grid item xs={3}></Grid>
								<Grid item xs={12} lg={4}>
									<Button
										className={classes.createButton}
										onClick={submitForm}
										style={{ marginTop: 10, fontSize: 16 }}
										disabled={isSubmitting}>
										CONTINUE
									</Button>
								</Grid>
								<Grid item xs={4}></Grid>
							</Grid>
						</Form>
					</>
				)}
			</Formik>
		</>
	);
};

export default FlightSummaryReturnForm;
